/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:177dafd9-f49b-4d75-99c9-f294b457c6e5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_GGdj2XDoR",
    "aws_user_pools_web_client_id": "4hqraepfnsc4jl2kqv3dts4tv6",
    "oauth": {},
    "aws_user_files_s3_bucket": "amplify-ng-app-stored-files180151-conygre",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_content_delivery_bucket": "ng-secure-files-conygre",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://ng-secure-files-conygre.s3-website-eu-west-1.amazonaws.com"
};


export default awsmobile;
